<template>
  <div class="notfound v-flex v-flex-wrap v-col-center v-row-center">
    <div class="img v-flex v-row-center"><img :src="require('../../assets/images/status/404.gif')" alt=""></div>
    <div class="text">
      <el-button @click="backHome" type="primary" round icon="el-icon-s-home">返回首页</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "404",
  methods: {
    backHome() {
      this.$router.replace({ path: "/" });
    }
  }
};
</script>

<style lang="scss" scoped>
.notfound {
  width: 100%;
  height: 100%;

  .img {
    width: 100%;
    height: auto;

    img {
      width: 60%;
      height: 60%
    }
  }

  .text {
    width: 100%;
    text-align: center;
  }
}
</style>